module.exports = __webpack_public_path__ + "media/images/youtube-489610b5d18f5f51d2ee43d59fb39cda.svg";